
import React, { useState } from 'react';
import ModalComponent from "../../components/Modal";
import "./confirmModal.scss";

const Confirm = ({
    open = false,
    title = 'Tem certeza?',
    message = 'Você tem certeza que deseja continuar?',
    confirmButtonText = 'Sim, tenho certeza',
    confirmButtonAction,
    cancelButtonText = 'Cancelar',
    cancelButtonAction,
    showCancelButton = true,
    showConfirmButton = true,

}) => {

    const [modalOpen, setModalOpen] = useState(open);

    const cancel = () => {
        setModalOpen(false);
        open = false;
        if (cancelButtonAction) {
            cancelButtonAction();
        }
    }

    return (
        <div>
            <ModalComponent
                openModal={open}
                closeModal={() => { cancel() }}
                auto
                confirm
                preventClose={true}
            >
                <div className="confirmModal">
                    <div className="title">
                        {title}
                    </div>
                    <div className="message" dangerouslySetInnerHTML={{__html: message}} >
                        
                    </div>
                    <div className="buttons">
                        {showConfirmButton ? (
                            <button type="button" className="confirmButton" onClick={confirmButtonAction}>
                                {confirmButtonText}
                            </button>
                        ) : null}
                        {showCancelButton ? (
                            <button type="button" className="cancelButton" onClick={() => { cancel() }}>
                                {cancelButtonText}
                            </button>
                        ) : null}
                    </div>
                </div>
            </ModalComponent>
        </div>
    )
}

export default Confirm;